import AccountingService from '@/services/accounting.service.js'
const state = {
    years: [],
  loading: false,
    chartOfAccounts: []
}
const actions = {
    async AddAccountingYear({ commit, dispatch }, payload) {
        try {
            commit('SET_LOADING', true)
            const response = await AccountingService.AddAccountingYear(payload)
            dispatch(
        'notification/showSuccess',
        response.payload.message,
        { root: true }
            )
            return response
        } catch (error) {
      console.log('haha', error)
      const message =
        error ||
        'Login failed. Please try again.'

      dispatch(
        'notification/showError',
        message,
        { root: true }
      )

      throw error
    } finally {
      commit('SET_LOADING', false)
    }
},
    async GetAccountingYears({ commit, dispatch }) {
    try {
      const response = await AccountingService.GetAccountingYears()
      const data = response.payload.responseData || response.payload || response

      commit('SET_ACCOUNTING_YEARS', data)
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load accounting years',
        { root: true }
      )
      throw error
    }
  },
    async SetActiveYear({ state, commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const year = state.years.find(y => y.id === id)
      if (!year) throw new Error('Accounting year not found')
      const payload = {
        name: year.name,
        startDate: year.startDate,
        endDate: year.endDate,
        isActive: true,
        isClosed: year.isClosed || false
      }
      const response = await AccountingService.UpdateAccountingYear(id, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Accounting year updated successfully',
        { root: true }
      )
      await dispatch('GetAccountingYears')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || error || 'Failed to update accounting year',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
    async fetchChartOfAccounts({ commit, dispatch }) {
    try {
      const response = await AccountingService.fetchChartOfAccounts()
      const data = response.payload.responseData || response.payload || response
      const mapped = mapAccounts(data)
      commit('SET_CHART_OF_ACCOUNTS', mapped)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load chart of accounts',
        { root: true }
      )
      throw error
    }
  },
    async addChartOfAccount({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await AccountingService.AddChartOfAccount(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Account added successfully',
        { root: true }
      )
      await dispatch('fetchChartOfAccounts')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to add account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
    async updateChartOfAccount({ commit, dispatch }, { id, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await AccountingService.UpdateChartOfAccount(id, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Account updated successfully',
        { root: true }
      )
      await dispatch('fetchChartOfAccounts')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
    async deleteChartOfAccount({ commit, dispatch }, id) {
    try {
      commit('SET_LOADING', true)
      const response = await AccountingService.DeleteChartOfAccount(id)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Account deleted successfully',
        { root: true }
      )
      await dispatch('fetchChartOfAccounts')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete account',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
    async AddJournalVoucher({ commit, dispatch }, payload) {
        try {
            commit('SET_LOADING', true)
            const response = await AccountingService.AddJournalVoucher(payload)
            dispatch(
        'notification/showSuccess',
        response.payload.message,
        { root: true }
            )
            return response
        } catch (error) {
      const message =
        error ||
        'Journal Voucher Add Failed. Please try again.'

      dispatch(
        'notification/showError',
        message,
        { root: true }
      )

      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
     async fetchJournalVouchers({ dispatch }) {
    try {
      const response = await AccountingService.fetchJournalVouchers()
      const data = response.payload.responseData || response.payload || response
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load journal vouchers',
        { root: true }
      )
      throw error
    }
  }
}
const mutations = {
  SET_ACCOUNTING_YEARS(state, years) {
    state.years = years
    },
    SET_LOADING(state, value) {
    state.loading = value
  },
    SET_CHART_OF_ACCOUNTS(state, payload) {
    state.chartOfAccounts = payload
  }
}
function mapAccounts(items) {
  return items.map(item => {
    const children = mapAccounts(item.childrens || [])
    const childDebit = children.reduce((sum, c) => sum + (c.totalDebit || 0), 0)
    const childCredit = children.reduce((sum, c) => sum + (c.totalCredit || 0), 0)
    const childBalance = children.reduce((sum, c) => sum + (c.balance || 0), 0)
    const totalDebit = (item.totalDebit || 0) + childDebit
    const totalCredit = (item.totalCredit || 0) + childCredit
    return {
      id: item.id,
      code: item.code,
      name: item.name,
      description: item.description || '',
      parentID: item.parentID,
      type: item.isTransactionAccount ? 'account' : 'category',
      category: resolveCategory(item.code),
      totalDebit,
      totalCredit,
      balance: item.balance ? item.balance : childBalance,
      expanded: true,
      children
    }
  })
}
function resolveCategory(code) {
  if (code.startsWith('1')) return 'Asset'
  if (code.startsWith('2')) return 'Liability'
  if (code.startsWith('3')) return 'Equity'
  if (code.startsWith('4')) return 'Revenue'
  if (code.startsWith('5')) return 'Expense'
  return 'Other'
}
export default {
   namespaced: true,
  state,
  actions,
  mutations
}
